module.exports = __webpack_public_path__ + "img/Logout-mobile.0718c2ea.svg";